import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-accept-conditions-confirmation-dialog',
  templateUrl: './accept-conditions-confirmation-dialog.component.html',
  styleUrls: ['./accept-conditions-confirmation-dialog.component.scss'],
})
export class AcceptConditionsConfirmationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<AcceptConditionsConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  confirm() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
